import { ref } from 'vue';

interface UseUnsavedChangesModalOptions {
  onConfirm: () => void;
  onCancel: () => void;
}

export function useUnsavedChangesModal({ onConfirm, onCancel }: UseUnsavedChangesModalOptions) {
  const isModalOpen = ref(false);

  const showModal = () => {
    isModalOpen.value = true;
  };

  const handleConfirm = () => {
    isModalOpen.value = false;
      onConfirm();
  };

  const handleCancel = () => {
    isModalOpen.value = false;
    onCancel();
  };

  return {
    isModalOpen,
    showModal,
    handleConfirm,
    handleCancel,
  };
} 